import React from 'react';
import { Box, Typography } from '@mui/material';
import loaderLogo from "../../../../assets/images/loaderLogo.svg";

export const Loader = () => {
  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      justifyContent="center" 
      alignItems="center" 
      height="100vh"
    >
      <Box
        component="img"
        src={loaderLogo}
        alt="Loading..."
        sx={{
          width: 100,
          height: 100,
          animation: 'flip 1.5s ease-in-out infinite',
          '@keyframes flip': {
            '0%': {
              transform: 'perspective(400px) rotateX(0)',
            },
            '100%': {
              transform: 'perspective(400px) rotateX(360deg)',
            },
          },
          transformStyle: 'preserve-3d',
          backfaceVisibility: 'visible',
        }}
      />
      <Typography variant="h6" sx={{ marginTop: 2 }}>
        Завантаження...
      </Typography>
    </Box>
  );
};
